(function () {
  function amount(track) {
    var card = track.querySelector('.product-lineup__product');
    if (!card) return track.clientWidth * 0.85;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 14;
    return card.getBoundingClientRect().width + gap;
  }

  function initTrack(track) {
    if (!track || track.dataset.hscroll) return;
    track.dataset.hscroll = '1';

    var wrap = document.createElement('div');
    wrap.className = 'hscroll';
    track.parentNode.insertBefore(wrap, track);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hscroll-btn prev';
    prev.setAttribute('aria-label', 'Scroll left');
    prev.innerHTML = '&larr;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hscroll-btn next';
    next.setAttribute('aria-label', 'Scroll right');
    next.innerHTML = '&rarr;';

    wrap.appendChild(prev);
    wrap.appendChild(track);
    wrap.appendChild(next);

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -amount(track), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: amount(track), behavior: 'smooth' });
    });

    function update() {
      var canScroll = track.scrollWidth - track.clientWidth > 4;
      wrap.classList.toggle('has-scroll', canScroll);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 300);
  }

  function boot() {
    document.querySelectorAll('[data-product-lineup-grid]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var grid = event.target && event.target.querySelector('[data-product-lineup-grid]');
    if (grid) {
      delete grid.dataset.hscroll;
      if (grid.parentElement && grid.parentElement.classList.contains('hscroll')) {
        var wrap = grid.parentElement;
        wrap.parentNode.insertBefore(grid, wrap);
        wrap.remove();
      }
      initTrack(grid);
    }
  });
})();
